/**
 * Removes the 'Disposable' type from the data type, making it
 * consumable by Hono RPC type instantiation.
 */
export function wrapRpcData(data) {
    return data;
}
//# sourceMappingURL=rpcUtil.js.map